"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyleDiv = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
const StyleDiv = exports.StyleDiv = _styledComponents.default.div.withConfig({
  displayName: "StyleDiv",
  componentId: "sc-e7n0wk-0"
})(["margin-bottom:8px;"]);